import styled from 'styled-components'

export const StyledOnBoardingWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  a {
    margin-top: 35px;
  }
`
